import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { t } from 'i18next';
import { ObjectStat } from '../../../../common/reports/models/ObjectStat';
import { PAGE_BREAK_AVOID } from '../../constants/constants';

type Props = {
  stats: ObjectStat[];
};

export const StatsTable = ({ stats }: Props) => {
  return (
    <Paper variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={3} sx={{ pb: 0, border: 'none' }}>
              <Typography component="span" variant="h5">
                {t('statistics')}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('type')}</TableCell>
            <TableCell>{t('returnValue')}</TableCell>
            <TableCell>{t('count')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stats.map((s, i) => (
            <TableRow key={i} sx={{ verticalAlign: 'top', ...PAGE_BREAK_AVOID }}>
              <TableCell>{s.getType()}</TableCell>
              <TableCell>
                <Box sx={{ fontWeight: 500 }}>{t('all')}</Box>
                {s.getStats().map((ss, ii) => (
                  <Box key={ii} sx={{ mt: 1 }}>
                    {ss.getValue()}
                  </Box>
                ))}
              </TableCell>
              <TableCell>
                <Box sx={{ fontWeight: 500 }}>{s.getTotalCount()}</Box>
                {s.getStats().map((ss, ii) => (
                  <Box key={ii} sx={{ mt: 1 }}>
                    {ss.getCount()}
                  </Box>
                ))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};
